export default __webpack_public_path__ + "static/media/logoHero.5be03d72.jpg";